import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';

const AboutPart5: React.FC = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';

    /** ============
     *   多语言内容
     * ============ */
    const text = {
        zh: {
            title: '奈尔简介',
            content: `
上海奈尔律师事务所首发国内专业数字法律服务交互平台，
率先将智能化、数字化应用到实际法律服务场景中。
同时搭建全球法律服务中心，和新加坡JINGSHI LAW FIRM SINGAPORE LLP
以及日本OTANI&Partners等多家海外律所建立长期稳定的战略合作伙伴关系，
协同新加坡园区、EZCO企业全球化加速器，
为资本跨境流动和企业的全球化运营提供了至关重要的法律保障和战略支持，
为本土律师突破执业壁垒提供资源保障。
奈尔始终致力于为国内外客户提供专业、全面、及时、优质、高效的法律服务。
`
        },
        en: {
            title: 'About NEXTOOK',
            content: `
NEXTOOK Law Firm Shanghai pioneered a professional digital legal service interaction platform in China,
taking the lead in applying intelligence and digitalization to real legal service scenarios.
We have built a Global Legal Service Center and established long-term strategic partnerships with
JINGSHI LAW FIRM SINGAPORE LLP in Singapore, OTANI & Partners in Japan, and other international firms.
Together with Singapore innovation parks and the EZCO global acceleration platform,
we provide critical legal support and strategic resources for cross-border capital flow and global business expansion.
Meanwhile, we empower local lawyers with essential resources to overcome professional barriers.
NEXTOOK is committed to providing professional, comprehensive, timely, high-quality and efficient legal services
to clients around the world.
`
        }
    };

    const t = languageCode === 'en' ? text.en : text.zh;

    /** 将换行符 \n 转换成 <br/> */
    const renderMultiline = (text: string) =>
        text.split('\n').map((line, idx) =>
            line.trim() ? <div key={idx}>{line}</div> : <br key={idx} />
        );

    return (
        <div>
            <div className='about-h1'>{t.title}</div>

            <div className='about-h2'>
                {renderMultiline(t.content)}
            </div>
        </div>
    );
};

export default AboutPart5;
